module.exports = __webpack_public_path__ + "static/media/un.4112bed6.svg";